const quoteList = [
  {
    text: 'Genius is one percent inspiration and ninety-nine percent perspiration.',
    author: 'Thomas Edison',
  },
  {
    text: 'Fate is in your hands and no one elses',
    author: 'Byron Pulsifer',
  },
  {
    text: 'What you give is what you get.',
    author: 'Byron Pulsifer',
  },
  {
    text: 'Life is change. Growth is optional. Choose wisely.',
    author: 'Karen Clark',
  },
  { text: 'One faces the future with ones past.', author: 'Pearl Buck' },
  { text: 'A goal without a plan is just a wish.', author: 'Larry Elder' },
  {
    text: 'The best teacher is experience learned from failures.',
    author: 'Byron Pulsifer',
  },
  { text: 'You give before you get.', author: 'Napoleon Hill' },
]

export default quoteList
